


























import { Component, Watch, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class InputSearch extends Vue {
  @Prop({ type: String, default: "" }) placeholder!: string;
  search = "";
  searchTimer: ReturnType<typeof setTimeout> | null = null;

  @Watch("search")
  changeSearch(): void {
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.$emit("changeSeartch", this.search);
      this.$emit("search", this.search);
    }, 300);
  }
}
